export interface ScriptTestResponse {
  code: ScriptTestResultType;
  data: string;
  consoleOutput: string[];
}

export enum ScriptTestResultType {
  FAILED = 0,
  OK = 1,
  SKIP = 2,
}
